import containerFuild from '../html-snippets/container-fuild.js';
import buttonPrimary from '../../../views/website/products/components/description/ui-modules/button-primary/raw-html.js';
import css from '../css-snippets/section-banner-fastvaluedeal.js';

const buttonPrimaryHtml = buttonPrimary({
  text: '80% DISCOUNT | YES, I WANT WAVEMAX',
  backgroundColor: '#17BE4F',
  iconSuffix: {
    show: true,
    src: 'https://cdn.skyfastimg.com/images/2026/05/29/image-6a18f2b85fcd063bb840101d.png',
  },
  subBtn: {
    show: true,
    text: '30-Day Money-Back Guararantee',
  },
  radius: 8,
});

const html = `
<div class="container">
  <div class="wrap-content">
    <div data-show="true" data-attribute="title-banner" class="title-banner">
      <h2><strong>Access 100+ Tv Channels Paying ZERO For Cable Fees</strong></h2>
      <p>Watch Movies, Sports, TV Shows, News For Free</p>
    </div>
    <div data-show="true" data-attribute="key-features" class="key-features">
      <div data-attribute="key-feature-item" class="key-feature-item">
        <div data-attribute="key-feature-item-icon" class="key-feature-item-icon">
          <img data-attribute="key-feature-item-icon-image" src="https://cdn.skyfastimg.com/images/2026/05/28/image-6a17b76b53e44f66bdac23fb.png" alt="" />
        </div>
        <div data-attribute="key-feature-item-content" class="key-feature-item-content">
          <h3>Powerful 120 PSI</h3>
        </div>
      </div>
      <div data-attribute="key-feature-item" class="key-feature-item">
        <div data-attribute="key-feature-item-icon" class="key-feature-item-icon">
          <img data-attribute="key-feature-item-icon-image" src="https://cdn.skyfastimg.com/images/2026/05/28/image-6a17b76b53e44f66bdac23fb.png" alt="" />
        </div>
        <div data-attribute="key-feature-item-content" class="key-feature-item-content">
          <h3>Powerful 120 PSI</h3>
        </div>
      </div>
      <div data-attribute="key-feature-item" class="key-feature-item">
        <div data-attribute="key-feature-item-icon" class="key-feature-item-icon">
          <img data-attribute="key-feature-item-icon-image" src="https://cdn.skyfastimg.com/images/2026/05/28/image-6a17b76b53e44f66bdac23fb.png" alt="" />
        </div>
        <div data-attribute="key-feature-item-content" class="key-feature-item-content">
          <h3>Powerful 120 PSI</h3>
        </div>
      </div>
    </div>
    <div
      data-max-width-small="430"
      data-show="true"
      data-attribute="img-small-banner"
      class="img-small-banner"
      style="--max-width-small: 430px"
    >
      <img data-attribute="img-small-banner-image" src="https://cdn.skyfastimg.com/images/2026/05/28/image-6a17ba7f5d8b3ad3012bb23c.png" alt="" />
    </div>
    ${buttonPrimaryHtml}
  </div>
</div>
`;

export default containerFuild(html, css, {
  backgroundImage: 'https://cdn.skyfastimg.com/images/2026/06/04/image-6a20e0c6189fbda6dbf5c734.jpg?w=1000',
});
